<div class="pdf-page-break-preview">
  <div class="break-line"></div>
  <div class="break-label">
    <mat-icon>insert_page_break</mat-icon>
    <span>Page Break</span>
  </div>
  <div class="break-line"></div>
</div>
